import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { worklogM } from 'src/app/Models/BasicForms/worklogM';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-worklog',
  templateUrl: './worklog.component.html',
  styleUrls: ['./worklog.component.css']
})
export class WorklogComponent implements OnInit {
  @Input() data: worklogM;
  @Input() dataType: number;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  formTitle = "Worklog";

  ngOnInit(): void { }

  getWorklogIDWise(type, typeID) {
    this.loadingRecords = true;
    let filterStr = " and TYPE=" + type + " and TYPE_ID=" + typeID;

    this._apiService.getAllWorklogs(this.pageIndex, this.pageSize, 'ID', 'desc', filterStr).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.worklogData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["TYPE", "Type"], ["TYPE_ID", "Type ID"], ["USER_ID", "User ID"], ["SPENT_HOURS", "Spent Hours"], ["SPENT_MINUTES", "Spent Minutes"], ["SPENT_SECONDS", "Spent Seconds"], ["WORK_DESCRIPTION", "Description"], ["WORKED_DATETIME", "Worked date Time"]];
  filterQuery: string = "";
  isloadSpinning = false;
  loadingRecords = false;
  worklogData: [];

  getAllWorklogs(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext = 'Filter Applied - worklog Master form"+ sort +" "+this.sortKey +" KEYWORD [F - worklog Master] ';
      this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        if (successCode['code'] == "200") {

        }
        else {

        }
      });
    } catch (error) {
      sort = "";
    }


    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }

    this.logtext = 'Filter Applied - worklog Master form "+ likeQuery +" KEYWORD [F - worklog Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });

    this._apiService.getAllWorklogs(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.worklogData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  drawerVisible = false;
  drawerTitle = "";
  worklogDrawerData: worklogM = new worklogM();

  typeForWorklogDrawer: number;
  typeIDForWorklogDrawer: number;

  add() {
    this.drawerTitle = "Create Worklog";
    this.worklogDrawerData = new worklogM();
    this.drawerVisible = true;
    this.worklogDrawerData.IS_ACTIVE = true;

    this.worklogDrawerData.TYPE = this.dataType;
    this.worklogDrawerData.TYPE_ID = this.data.ID;

    this.typeForWorklogDrawer = this.dataType;
    this.typeIDForWorklogDrawer = this.data.ID;

    this.logtext = 'ADD - Worklog Master form KEYWORD [A - Worklog Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  edit(data: worklogM) {
    this.drawerTitle = "Worklog Details";
    this.worklogDrawerData = Object.assign({}, data);
    this.drawerVisible = true;

    this.worklogDrawerData.TYPE = this.dataType;
    this.worklogDrawerData.TYPE_ID = this.data.ID;

    this.typeForWorklogDrawer = this.dataType;
    this.typeIDForWorklogDrawer = this.data.ID;

    this.logtext = 'EDIT - Worklog Master form KEYWORD [E - Worklog Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  drawerClose() {
    this.getWorklogIDWise(this.dataType, this.data.ID);
    this.drawerVisible = false;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  sortKey: string = "id";
  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    // this.getAllWorklogs();
  }
}
